import React, { useState } from 'react';
import { Connection, Transaction, PublicKey } from '@solana/web3.js';
import { getTokenMetadata } from "@solana/spl-token";
import base58, * as bs58 from "bs58";
import { useConnection, useWallet } from '@solana/wallet-adapter-react'
import { mint, finalize, claim, getClaims } from '../api/api';


const SolaiNft: React.FC = (props) => {
    //const { connection } =  useConnection(); //new Connection('https://api.devnet.solana.com', 'confirmed'); 
    const connection = new Connection("https://distinguished-hidden-ensemble.solana-mainnet.quiknode.pro/c84bf41567901af46ebf2006bfea7a83c047fe1b/", "finalized");
    const { wallet, publicKey, signTransaction, sendTransaction } = useWallet();

    const [isMinting, setMinting] = useState(false);
    const [isClaiming, setClaiming] = useState(false);
    const [isClaimable, setClaimable] = useState(false);

    const [mintingMessage, setMintingMessage] = useState("");
    const [claimingMessage, setClaimingMessage] = useState("");
    const [mintedData, setMintedData] = useState({});

    const { collectionId, collectionName, collectionOwner, collectionImageUrl, collection } = props;


    const handleMint = async (id, collectionOwner, publicKey) => {
        try {
            const result = await mint(collectionOwner, id, publicKey);
            return result;
        } catch (error) {
            console.error('Error minting:', error);
            throw new Error('Error minting, please try again');
        }
    }

    const handleFinalize = async (id: number, collectionOwner: string, publicKey: string, placeholderMint: string) => {
        try {
            const result = await finalize(id, collectionOwner, placeholderMint, publicKey);
            console.log("finalised called")
            console.log(result);
            return result;
        } catch (error) {
            console.error('Error finalizing:', error);
            throw new Error('Error finalizing the transaction, please try again');
        }
    }

    const handleClaim = async (collectionOwner: string, publicKey: string,) => {
        try {
            const result = await claim(collectionOwner, publicKey);
            console.log(result);
            return result;
        } catch (error) {
            console.error('Error claiming:', error);
        }
    }

    const handleGetClaims = async (collectionOwner: string, publicKey: string,) => {
        try {
            const result = await getClaims(collectionOwner, publicKey);
            console.log(result);
            return result;
        } catch (error) {
            console.error('Error Get Claim:', error);
        }
    }

    const resetMinting = () => {
        setMinting(false);
        setMintingMessage("");
    }

    const resetClaiming = () => {
        setClaiming(false);
        setClaimingMessage("");
    }


    const onClickCreatePurchase = React.useCallback(async () => {
        if (publicKey == null) {
            alert('Wallet not connected, use the button on the top right of the page');
            return
        }
        setMinting(true);
        // Query API for Solana tx
        setMintingMessage("Connecting with your wallet");

        //MINT CALL  HERE 
        let confirmation = false;
        const transaction = await handleMint(collectionId, collectionOwner, publicKey.toBase58());
        console.log(transaction);

        if (!transaction) {
            return alert("Error minting, please try again")
        }

        try {
            setMintingMessage("Please confirm transaction");
            //signature 
            const tx = Transaction.from(Buffer.from(transaction.transaction, "base64"));
            console.log(tx);

            const signature = await sendTransaction(tx, connection, { skipPreflight: true });
            console.log(["Transac sent, waiting confirmation from user. Signature:", signature])

        } catch (e) {
            // show error 
            alert("Error signing the transaction, please try again. Error: " + e.message);
        }

        setMintingMessage("...Minting");
        console.log(transaction);
        try {
            console.log(["Starting getTokenMetadata", transaction.placeholder_mint]);
            const placeholder_metadata = await getTokenMetadata(connection, new PublicKey(transaction.placeholder_mint));
            console.log(["Finished getTokenMetadata", placeholder_metadata]);
            const additional_metadata = placeholder_metadata!.additionalMetadata;
            const _id = additional_metadata[0][1];
            const token_id = additional_metadata[1][1];
            console.log(["additional_metadata", additional_metadata]);
            const imageUrl = collectionImageUrl.replace("#token_id", token_id);
            console.log(['URL TO POLL: ', imageUrl]);
            //call finalize 
            const responseFinalise = await handleFinalize(_id, collectionOwner, publicKey.toBase58(), transaction.placeholder_mint);
            console.log(responseFinalise);
            if (responseFinalise) {
                const mintedData = { address: imageUrl, name: collectionName + " #" + token_id, id: token_id };
                setMintedData(mintedData);
            }
        } catch (e) {
            // show error 
            console.log(["Error minting your nft", e])
            alert("Error minting your nft, please try again. " + e.message);
        }
        resetMinting();

    }, [wallet, connection, publicKey, useWallet()]);

    const onClickCreateClaim = React.useCallback(async () => {
        if (publicKey == null) {
            alert('Wallet not connected');
            return
        }
        setClaiming(true);
        setClaimingMessage("Connecting with your wallet and claiming...");

        //getClaims is called here because we want to be sure right now some other tokens can be minted
        const response = await handleGetClaims(collectionOwner, publicKey.toBase58());
        console.log(["get claim possible claims", response]);
        setClaimingMessage("Claim in progress...");
        setClaiming(true);
        if (response) {
            if (response.tokens.length > 0) {
                const tokens = response.tokens.sort((a, b) => a - b); // we must take tokens and take the first in ascending order
                const token_id = tokens[0];
                console.log(token_id);

                //call finalize 
                const imageUrl = collectionImageUrl.replace("#token_id", token_id);
                console.log('URL TO POLL XXX: ', imageUrl);
                const mintedData = { address: imageUrl, name: collectionName + " #" + token_id, id: token_id };

                // here we claim 
                const responseClaim = await handleClaim(collectionOwner, publicKey.toBase58());
                console.log(["claim", responseClaim]);

                if (responseClaim) {
                    // {"transactions":[{"tx_signature":"4PmvaashLBmLCDykYNfMCtn7e8nCT2LZNaU6bZvCy587SPT8FbzF1q5o9VYmAE3C3MhfLAJZ1H5SofXznUzzZYrf","nft_mint":"AUSjXTw5BKyxgrt2V3GK6eejHK57MzgJjdkcwBBBykqw"}]}
                    setMintedData(mintedData);

                    console.log(responseClaim);
                } else {
                    // NOT WORKING
                    alert("We were not able to claim for you, please try again");
                }
            } else {
                alert("You don't have any more claims with your wallet");
            }
        } else {
            // NOT WORKING
            alert("We can't check for the moment if any items can be claimed, please try again");
        }

        resetClaiming();

    }, [wallet, connection, publicKey, useWallet()]);

    // Sending new mint data to parent page
    React.useEffect(() => {

        if (mintedData.address) {
            props.claimNftCallback(mintedData);
        }
    }, [mintedData]);

    // to calling handleGetClaims here: if empty the button claim must disappear
    React.useEffect(() => {
        if (publicKey) {
            checkClaimable();
            console.log("check claimable...")
        }
    }, [publicKey]);

    async function checkClaimable() {
        const response = await handleGetClaims(collectionOwner, publicKey.toBase58()); //{tokens : []};
        if (response && response.tokens.length > 0) {
            setClaimable(true);
            return;
        }
    }

    return (
        <>
            {!isClaiming && isMinting
                ? (<>
                    <button className='button arrow mint'>{mintingMessage} </button>
                </>)
                : (<>
                    <button className='button arrow mint' onClick={onClickCreatePurchase}>Mint for {collection ? (collection.price).toFixed(2) : "X"} SOL</button>
                </>)
            }
            {isClaimable ? (
                isClaiming && !isMinting
                    ? (<>
                        <button className='button arrow mint'>{claimingMessage} </button>
                    </>)
                    : (<>
                        <button className='button arrow mint' onClick={onClickCreateClaim}>Claim for free</button>
                    </>)
            ) : (<></>)
            }
        </>
    )
};

export default SolaiNft;